/**
 * StruttureTree - Page Shell
 * Redirect a Strutture
 */

import { useEffect } from "react";

export default function StruttureTree() {
  useEffect(() => {
    window.location.href = "/strutture";
  }, []);
  return null;
}
